import { render } from "./ClientDashboardView.vue?vue&type=template&id=249625ef&scoped=true"
import script from "./ClientDashboardView.vue?vue&type=script&lang=js"
export * from "./ClientDashboardView.vue?vue&type=script&lang=js"

import "./ClientDashboardView.vue?vue&type=style&index=0&id=249625ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249625ef"]])

export default __exports__